import { objectZip } from '../../helpers/object.js';
import { getNonContentWidth, getElementWidth } from '../../helpers/style.js';
export function getViewMetricsFromContainer(containerElement, itemKeys) {
    const itemElements = Array.from(containerElement.children);
    return {
        outerFrameWidth: getNonContentWidth(containerElement),
        itemWidths: getItemWidthsFromItemDomElements(itemKeys, itemElements),
    };
}
function getItemWidthsFromItemDomElements(itemKeys, itemElements) {
    const itemWidths = itemElements.map(getElementWidth);
    return objectZip(itemKeys, itemWidths);
}
